'use strict';

var toString = Object.prototype.toString;

function isFunc(obj) {
  return toString.call(obj) === '[object Function]';
}

module.exports = isFunc;



//////////////////
// WEBPACK FOOTER
// ./node_modules/inflected/lib/isFunc.js
// module id = 1129
// module chunks = 0